"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _favourite = require("../styles/favourite"),
    _Icon = _interopRequireDefault(require("../../Icon"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Favourite = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onFavouriteClick = function (a) {
      d.setState(function (a) {
        return {
          isFavourite: !a.isFavourite
        };
      }), a && a();
    }, d.state = {
      isFavourite: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props.isFavourite;
      this.setState({
        isFavourite: a
      });
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props.action,
          c = this.state.isFavourite;
      return _react["default"].createElement(_Icon["default"], {
        onClick: function onClick() {
          return a.onFavouriteClick(b);
        },
        name: "favourite",
        color: c && "dandelion",
        className: (0, _classnames["default"])("favourite-icon", _favourite.CARD_OVERLAY_FAV_ICON)
      });
    }
  }]), b;
}(_react.Component),
    _default = Favourite;

exports["default"] = _default;